wbApp.controller('LeadsAssignCourseDetailCtrl', ['$scope', '$modal', '$translate', '$q', '$filter', 'leadSvc',
    'courseRegistrationSvc', 'courseSvc', 'semesterSvc', 'securitySvc',
function ($scope, $modal, $translate, $q, $filter, leadSvc, courseRegistrationSvc, courseSvc, semesterSvc, securitySvc) {

    $scope.model = {
        semesterID: null,
        courseID: null,
        notes: null
    };
    
    if ($scope.leadSourceType === 5) { // CourseInterest
        courseRegistrationSvc.getCourseInterestById($scope.leadSourceReferenceId).$promise.then(function (data) {
            if (!!data) {
                $scope.model.courseID = data.courseId;
                $scope.model.notes = data.notes;
            }            
        });
    }
        
        
    $scope.assignExistingRegistration = false;
    $scope.studentRegistrations = [];
    $scope.existingRegistration = null;

    $scope.canBeSaved = function () {
        if ($scope.assignExistingRegistration) {
            return !!$scope.existingRegistration;
        }

        return true;
    }

    $scope.onAssignExistingCourseBtnClick = function () {
        $scope.assignExistingRegistration = true;
        $scope.existingRegistration = false;
        $scope.studentRegistrations = courseRegistrationSvc.getAllCoursesByStudent($scope.studentId);
    }

    $scope.onCreateNewRegistrationBtnClick = function () {
        $scope.assignExistingRegistration = false;
    }

    $scope.onExistingRegistrationRowSelected = function (row) {
        $scope.existingRegistration = row;
    }

    $scope.isSaving = false;
    var isSaving2 = false;

    semesterSvc.getDefaultAsync().then(function (data) {
        if (!!data) {
            $scope.model.semesterID = data.id;
        }
    });

    $scope.onDetailSave = function (model) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if ($scope.assignExistingRegistration && $scope.existingRegistration) {
            leadSvc.getById($scope.leadId).$promise.then(function (lead) {

                isSaving2 = true;

                lead.conversionType = 1; // CourseRegistration
                lead.conversionReferenceId = $scope.existingRegistration.courseRegistrationID;
                lead.conversionDateUtc = moment().toDate();
                var courseFullName = $scope.existingRegistration.courseFullName;
                var firstLesson = !!$scope.existingRegistration.firstDate
                    ? ' (' + $filter('date')($scope.existingRegistration.firstDate, 'EEE HH:mm').toUpperCase() + ')'
                    : '';
                lead.conversionText = courseFullName + firstLesson;
                lead.status = 1; // Converted

                if (!lead.notes || lead.notes.length == 0) {
                    lead.notes = [];
                }

                var user = securitySvc.loggedInUser();

                lead.notes.push({
                    text: $translate.instant('TXT_TITLE_REGISTER_ON_COURSE') + ': ' + lead.conversionText,
                    updatedAtUtc: moment().toDate(),
                    updatedByUserId: user.userID + "",
                    updatedByName: user.fullName
                });

                leadSvc.update(lead).$promise.then(function () {
                    $scope.isSaving = false;
                    isSaving2 = false;
                    $scope.$hide();
                    $scope.onLeadSave(lead);
                }, function (error) {
                    $scope.detailError = error;
                    $scope.isSaving = false;
                    isSaving2 = false;
                });
            }, function (error) {
                $scope.detailError = error;
                $scope.isSaving = false;
            });

        } else {

            $q.all([
                leadSvc.getById($scope.leadId).$promise,
                courseSvc.getByCourseID(model.courseID).$promise]).then(function (lead_and_course) {

                    var lead = lead_and_course[0];
                    var course = lead_and_course[1];

                    if (lead.status == 1) {
                        $scope.detailError = { errors: [{ message: $translate.instant('TXT_ERROR_LEAD_ALREADY_CONVERTED') }] };
                        $scope.isSaving = false;
                    }
                    else {
                        $q.all([detailDialogPromise.$promise, courseRegistrationSvc.createNew(course, false)])
                        .then(function (data) {
                            var courseRegistration = data[1];
                            courseRegistration.parentID = lead.userId;
                            if (!!lead.studentIds && lead.studentIds.length > 0) {
                                courseRegistration.studentID = lead.studentIds[0];
                            }
                            courseRegistration.notes = model.notes;
                            detailDialogPromise.$scope.course = course;
                            detailDialogPromise.$scope.model = courseRegistration;
                            // Do not search for leads during course registration save
                            detailDialogPromise.$scope.ignoreLeadAssignment = true; 
                            detailDialogPromise.$scope.onAfterSuccessSave = function (cr) {

                                isSaving2 = true;

                                lead.conversionType = 1; // CourseRegistraction
                                lead.conversionReferenceId = cr.courseRegistrationID;
                                lead.conversionDateUtc = moment().toDate();

                                var courseFullName = $filter('courseFullName')(course);
                                var firstLesson = !!course.firstLesson
                                    ? ' (' + $filter('date')(course.firstLesson, 'EEE HH:mm').toUpperCase() + ')'
                                    : '';
                                lead.conversionText = courseFullName + firstLesson;
                                lead.status = 1; // Converted

                                if (!lead.notes || lead.notes.length == 0) {
                                    lead.notes = [];
                                }

                                var user = securitySvc.loggedInUser();

                                lead.notes.push({
                                    text: $translate.instant('TXT_TITLE_REGISTER_ON_COURSE') + ': ' + lead.conversionText,
                                    updatedAtUtc: moment().toDate(),
                                    updatedByUserId: user.userID + "",
                                    updatedByName: user.fullName
                                });

                                leadSvc.update(lead).$promise.then(function () {
                                    $scope.isSaving = false;
                                    isSaving2 = false;
                                    $scope.$hide();
                                    $scope.onLeadSave(lead);
                                }, function (error) {
                                    $scope.detailError = error;
                                    $scope.isSaving = false;
                                    isSaving2 = false;
                                });
                            };
                            detailDialogPromise.$scope.onAfterDialogCancel = function () {
                                $scope.isSaving = false;
                            };
                            detailDialogPromise.show();
                        }, function (error) {
                            $scope.detailError = error;
                            $scope.isSaving = false;
                        });
                    }
                }, function (error) {
                    $scope.detailError = error;
                    $scope.isSaving = false;
                })
        }
    }

    $scope.studentRegistrationsGridSettings = {
        name: 'studentRegistrationsAssing',
        keyExpr: 'courseRegistrationID',
        columns: [
            {
                dataField: 'courseRegistrationID',
                caption: $translate.instant('TXT_LBL_ID'),
                dataType: 'string',
                visible: false,
                showInColumnChooser: false
            },
            {
                dataField: 'registrationDate', caption: $translate.instant('TXT_SEC_CLIENT_COURSE_REGISTRATION'),
                dataType: 'date',
                format: { date: 'short' },
                width: '80px',
                sortOrder: 'desc'
            },
            {
                dataField: 'semesterName', caption: $translate.instant('TXT_LBL_SEMESTER'),
                dataType: 'string',
                width: '120px'
            },
            {
                dataField: 'firstDate',
                caption: $translate.instant('TXT_MENU_SCHEDULE'),
                dataType: 'date',
                format: { raw: "EEE HH:mm" },
                calculateSortValue: function (rowData) {
                    var mfirstLesson = moment(rowData.firstLesson);
                    return mfirstLesson.isValid()
                        ? mfirstLesson.day() * 10000 + mfirstLesson.hour() * 100 + mfirstLesson.minute()
                        : rowData.firstLesson;
                },
                width: '90px'
            },
            { dataField: 'courseFullName', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string' },
        ]
    };


    var detailDialogPromise = $modal({
        templateUrl: 'courses/courses/courses-detail-tabs/students-detail.html',
        show: false,
        onHide: function () { if (!isSaving2) { $scope.isSaving = false; } },
        scope: $scope.$new()
    });
}]);
